import * as React from "react"
import { DigitsButton } from "@digits-shared/DesignSystem/Button"
import { DigitsLinkButton } from "@digits-shared/DesignSystem/LinkButton"
import useSession from "@digits-shared/hooks/useSession"
import useStateBoolean from "@digits-shared/hooks/useStateBoolean"
import { useLogOut } from "src/frontend/components/Session/useLogOut"
import { slide } from "src/frontend/components/Shared/Glow/animations"
import { AnimatedWrapper, Biscuit } from "src/frontend/components/Shared/Glow/Biscuit"
import { Title } from "src/frontend/components/Shared/Glow/Header"
import routes from "src/frontend/routes"
import type FrontendSession from "src/frontend/session"

/*
  COMPONENTS
*/

export const LogOut: React.FC = () => {
  const session = useSession<FrontendSession>()
  const { value: disabled, setTrue: setDisabled } = useStateBoolean()
  const logOut = useLogOut()
  const onClick = React.useCallback(() => {
    setDisabled()
    if (session.doppelganger) {
      session.logoutDoppelganger()
    }
    logOut().then(() => session.clear())
  }, [session, logOut, setDisabled])

  return (
    <AnimatedWrapper key="logout" variants={slide} initial="initial" animate="animate">
      <Biscuit>
        <Title>Are you sure you want to sign out?</Title>
        <DigitsButton $fullWidth onClick={onClick} disabled={disabled} loading={disabled}>
          Sign Out
        </DigitsButton>
        <DigitsLinkButton
          $fullWidth
          $variant="secondary-dark"
          to={routes.root.generate()}
          disabled={disabled}
        >
          Cancel
        </DigitsLinkButton>
      </Biscuit>
    </AnimatedWrapper>
  )
}
